import registrationDictionary from '@entities/registration/i18n/ru/registration.dic.json';

export const registration = {
  REGISTRATION: registrationDictionary,
};

export const registrationNamespaces = ['REGISTRATION'];
